(() => {
  const product = document.querySelector('.ks-pdp');
  if (!product) return;
  product.querySelectorAll('[data-outfit-demo]').forEach(demo => {
    const warmImages = () => demo.querySelectorAll('[data-outfit-panel] img').forEach(image => { image.loading = 'eager'; });
    if ('IntersectionObserver' in window) {
      const imagesObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          warmImages();
          imagesObserver.disconnect();
        }
      }, {rootMargin:'600px'});
      imagesObserver.observe(demo);
    } else warmImages();
    demo.addEventListener('click', event => {
      const button = event.target.closest('[data-outfit-select]');
      if (!button || !demo.contains(button)) return;
      demo.querySelectorAll('[data-outfit-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      demo.querySelectorAll('[data-outfit-panel]').forEach(item => { item.hidden = item.dataset.outfitPanel !== button.dataset.outfitSelect; });
      demo.querySelector('[data-outfit-description]').textContent = button.dataset.outfitCopy;
    });
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const panel = product.querySelector('[data-pdp-order-panel]');
  const sticky = document.querySelector('[data-pdp-sticky]');
  let checkOrderReady = () => {};
  const variantData = product.querySelector('[data-variant-data]');
  if (variantData) {
    const {variants, copy} = JSON.parse(variantData.textContent);
    const colorIndex = Number(product.dataset.colorIndex);
    const sizeIndex = Number(product.dataset.sizeIndex);
    let current = variants.find(variant => String(variant.id) === product.dataset.displayVariant) || variants[0];
    let galleryColor = current?.options[colorIndex];
    let selected = Boolean(product.dataset.selectedVariant);
    const baseUrl = new URL(product.dataset.url, location.origin);
    const sizeLabel = variant => sizeIndex >= 0 ? variant.options[sizeIndex] : variant.title;
    const findVariant = (index, value) => variants.find(variant => variant.options[index] === value && variant.options.every((option, position) => position === index || option === current.options[position]));
    const variantUrl = variant => {
      const url = new URL(baseUrl);
      url.searchParams.set('variant', String(variant.id));
      return url.pathname + url.search;
    };
    const updateChoice = (element, variant, active, label) => {
      const available = Boolean(variant?.available);
      let choice = element;
      if (available && choice.tagName !== 'A') {
        choice = document.createElement('a');
        choice.textContent = element.textContent;
        choice.dataset.sizeValue = element.dataset.sizeValue;
        choice.dataset.sizeTitle = element.dataset.sizeValue;
        choice.setAttribute('aria-label', `${copy.size} ${element.dataset.sizeValue}`);
        element.replaceWith(choice);
      }
      if (variant) {
        choice.dataset.codVariant = String(variant.id);
        if (choice.tagName === 'A') choice.href = variantUrl(variant);
      }
      if (available) choice.removeAttribute('aria-disabled');
      else choice.setAttribute('aria-disabled', 'true');
      if (active) choice.setAttribute('aria-current', 'true');
      else choice.removeAttribute('aria-current');
      if (label) choice.dataset.sizeTitle = label;
    };
    const sync = (notify = false) => {
      if (!current) return;
      product.dataset.selectedSize = selected ? current.title : '';
      product.dataset.selectedVariant = selected ? String(current.id) : '';
      product.dataset.displayVariant = String(current.id);
      product.dataset.price = String(current.price);
      product.querySelectorAll('[data-color-value]').forEach(choice => {
        const sameSize = findVariant(colorIndex, choice.dataset.colorValue);
        const variant = sameSize || variants.find(item => item.options[colorIndex] === choice.dataset.colorValue && item.available);
        updateChoice(choice, variant, current.options[colorIndex] === choice.dataset.colorValue);
      });
      product.querySelectorAll('[data-size-value]').forEach(choice => {
        const variant = sizeIndex >= 0 ? findVariant(sizeIndex, choice.dataset.sizeValue) : variants.find(item => item.title === choice.dataset.sizeValue);
        updateChoice(choice, variant, selected && variant?.id === current.id, choice.dataset.sizeValue);
      });
      const label = selected ? `${copy.selected}: ${sizeLabel(current)}` : copy.choose_size;
      const feedback = product.querySelector('[data-size-feedback]');
      if (feedback) { feedback.textContent = label; feedback.hidden = !selected; }
      product.querySelectorAll('[data-selected-size-label]').forEach(element => { element.textContent = selected ? sizeLabel(current) : ''; });
      if (sticky) {
        const feedback = sticky.querySelector('[data-sticky-selection]');
        if (feedback) feedback.textContent = label;
      }
      const price = new Intl.NumberFormat('en-US', {maximumFractionDigits:2}).format(current.price / 100);
      product.querySelectorAll('[data-product-price]').forEach(element => { element.textContent = price; });
      sticky?.querySelectorAll('[data-product-price]').forEach(element => { element.textContent = price; });
      if (colorIndex >= 0) {
        product.dataset.color = current.options[colorIndex];
        product.querySelectorAll('[data-current-color-name]').forEach(element => { element.textContent = current.options[colorIndex]; });
        product.querySelectorAll('[data-photo-color]').forEach(photo => {
          if (photo.dataset.photoColor) photo.style.display = photo.dataset.photoColor === current.options[colorIndex] ? '' : 'none';
        });
        const swatch = product.querySelector('.ks-color-option[aria-current="true"] .ks-color-dot');
        if (swatch) product.querySelectorAll('[data-current-color-dot]').forEach(element => { element.style.setProperty('--shoe-color', swatch.style.getPropertyValue('--shoe-color')); });
      }
      const colorChanged = colorIndex >= 0 && current.options[colorIndex] !== galleryColor;
      if (current.image && notify && colorChanged) {
        const image = product.querySelector('.ks-image-zoom img');
        const large = document.getElementById(product.dataset.zoomId)?.querySelector('img');
        if (image) {
          const url = new URL(current.image, location.origin);
          url.searchParams.set('width', String(Math.min(1500, Math.max(480, Math.ceil(image.clientWidth * devicePixelRatio)))));
          image.removeAttribute('srcset');
          image.src = url.href;
          image.alt = `${product.dataset.title} — ${current.options[colorIndex]}`;
          product.dataset.image = url.href;
        }
        if (large) { large.removeAttribute('srcset'); large.src = current.image; large.alt = image?.alt || product.dataset.title; }
        product.querySelector('.ks-product-main-image')?.classList.remove('ks-styled-view');
        large?.closest('dialog')?.classList.remove('ks-styled-view');
        const note = product.querySelector('[data-gallery-note]');
        if (note) note.textContent = note.dataset.originalNote;
        const filename = new URL(current.image, location.origin).pathname;
        product.querySelectorAll('[data-photo]').forEach(button => { button.setAttribute('aria-pressed', String(new URL(button.dataset.photo, location.origin).pathname === filename)); });
      }
      galleryColor = current.options[colorIndex];
      const ready = selected && current.available;
      product.dataset.variantAvailable = String(ready);
      product.querySelectorAll('[data-native-order]').forEach(element => { element.hidden = !ready; });
      const status = product.querySelector('[data-variant-status]');
      if (status) { status.hidden = ready || !selected; status.textContent = selected ? copy.unavailable : copy.choose_size; }
      product.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(input => {
        input.value = selected ? String(current.id) : '';
        if (notify) input.dispatchEvent(new Event('change', {bubbles:true}));
      });
      if (notify) checkOrderReady();
    };
    sync();
    product.addEventListener('click', event => {
      const choice = event.target.closest('[data-cod-variant]');
      if (!choice || !product.contains(choice) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (choice.getAttribute('aria-disabled') === 'true') return;
      const variant = variants.find(item => String(item.id) === choice.dataset.codVariant);
      if (!variant) return;
      current = variant;
      selected = selected || choice.hasAttribute('data-size-value');
      sync(true);
      const url = new URL(location.href);
      url.searchParams.set('variant', String(current.id));
      history.replaceState(history.state, '', url);
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-pdp-order]')) {
      const target = product.querySelector('[data-cod-app-container] input[name="first_name"]:not([disabled]), [data-cod-app-container] input[type="tel"]:not([disabled])') || product.querySelector('[data-cod-size-picker] a[aria-current="true"], [data-cod-size-picker] a, [data-review-size]') || panel;
      target?.scrollIntoView({block:'center', behavior: reduced.matches ? 'auto' : 'smooth'});
      target?.focus({preventScroll:true});
    }
    if (event.target.closest('[data-open="ks-size-guide"]')) {
      const context = document.querySelector('[data-fit-context]');
      if (context) {
        context.textContent = [product.dataset.title, product.dataset.selectedSize].filter(Boolean).join(' · ');
        context.hidden = !context.textContent;
      }
    }
  });
  const orderApp = product.querySelector('[data-cod-app-container]');
  if (orderApp) {
    const initialFields = product.querySelector('[data-cod-initial]');
    let mounted = false;
    let observerFrame = 0;
    const mountFields = () => {
      if (mounted) return;
      const fields = ['first_name', 'phone', 'city'];
      if (!fields.every(name => orderApp.querySelector(`input[name="${name}"]`)) || !orderApp.querySelector('#es-form-button, .rsi-submit_button')) return;
      const active = document.activeElement;
      let focus;
      initialFields?.querySelectorAll('[data-order-field]').forEach(input => {
        const target = orderApp.querySelector(`input[name="${input.dataset.orderField}"]`);
        target.autocomplete = input.autocomplete;
        if (input.value) {
          target.value = input.value;
          target.dispatchEvent(new Event('input', {bubbles:true}));
          target.dispatchEvent(new Event('change', {bubbles:true}));
        }
        if (input === active) focus = {target, start:input.selectionStart, end:input.selectionEnd};
      });
      mounted = true;
      orderApp.dataset.pdpMounted = 'true';
      if (initialFields) initialFields.hidden = true;
      if (focus) {
        focus.target.focus({preventScroll:true});
        if (focus.start !== null && focus.end !== null) focus.target.setSelectionRange(focus.start, focus.end);
      }
    };
    const checkReady = () => {
      mountFields();
      const size = orderApp.querySelector('.es-product-title.variant, .rsi-product-item-subtitle')?.textContent.trim();
      const total = orderApp.querySelector('.es-p-price, .rsi-total-summary-total-value')?.textContent || '';
      const ready = mounted && product.dataset.variantAvailable === 'true' && size === product.dataset.selectedSize && /[1-9\u0661-\u0669\u06f1-\u06f9]/.test(total);
      orderApp.dataset.pdpReady = String(ready);
      const submit = orderApp.querySelector('#es-form-button, .rsi-submit_button');
      if (submit) {
        submit.inert = !ready;
        submit.setAttribute('aria-disabled', String(!ready));
      }
    };
    const queueCheckReady = () => {
      if (observerFrame) return;
      observerFrame = window.requestAnimationFrame(() => {
        observerFrame = 0;
        checkReady();
      });
    };
    checkOrderReady = checkReady;
    const guardSubmit = event => {
      if (orderApp.dataset.pdpReady === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    orderApp.addEventListener('submit', guardSubmit, true);
    orderApp.addEventListener('click', event => {
      if (event.target.closest('#es-form-button, .rsi-submit_button')) guardSubmit(event);
    }, true);
    checkReady();
    new MutationObserver(queueCheckReady).observe(orderApp, {childList:true, subtree:true, characterData:true});
  }
  if (sticky && panel && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      sticky.classList.toggle('ks-pdp-sticky-hidden', entries[0].isIntersecting);
    }, {threshold:0, rootMargin:'0px 0px -75px 0px'});
    observer.observe(panel);
  }
})();
